import Vue from 'vue';

export const clientsListingService = {
  async getClientDetails(reference_number, PaginationParameters) {
    return Vue.axios
      .get(`/clients/${reference_number}`, {
        params: { ...PaginationParameters }
      })
      .then(response => response.data);
  },
  async getClientDetailsHistories(reference_number) {
    return Vue.axios.get(`/clients/${reference_number}/history`).then(response => response.data);
  },

  async saveClientDetails(clientDetails, section) {
    clientDetails['section'] = section;
    return Vue.axios.post('/clients/client-details', clientDetails).then(response => response.data);
  }
};
